import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RouteFiltersState {
  sortBy: string;
  name: string;
  statusFilter: string;
  stateFilter: string;
}

const initialState: RouteFiltersState = {
  sortBy: '',
  name: '',
  statusFilter: 'pending',
  stateFilter: 'public',
};

const routeFiltersSlice = createSlice({
  name: 'routeFilters',
  initialState,
  reducers: {
    setRouteFilters(state, action: PayloadAction<any>) {
      state.name = action.payload.name;
      state.sortBy = action.payload.sortBy;
      state.statusFilter = action.payload.statusFilter;
      state.stateFilter = action.payload.stateFilter;
    },
  },
});

export const { setRouteFilters } = routeFiltersSlice.actions;
export default routeFiltersSlice.reducer;
